import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
// import "../pages/Plan.css";
import { accountService } from "../../services/accountService";
import iconImage from "../../assets/Icon.svg";
import CurrencyFormat from "react-currency-format";
import LogicContext from "../../Context/LogicContext";
import {imageService} from '../../services/image.service';

import {
  GetEntryData,
  SetEntryData,
  GetPurChaseOrderEdit,
  ResetPurChaseOrderEdit,
} from "../../store/purchaseOrderAtom";

import { useForm, Controller } from "react-hook-form";
import { format } from "date-fns";

import { useNavigate } from "react-router-dom";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import SearchIcon from "../../components/SearchIcon";

import PurchaseDeliverCheckBox from "./PurchaseDeliverCheckBox";
import AddPurchaseWarehouse from "./AddPurchaseWarehouse";
import PurchaseOrderPaymentTerms from "./PurchaseOrderPaymentTerms";
import PurchaseOrderRate from "./PurchaseOrderRate";
import APurchaseDiscountType from "./AddDiscountType";
import AddPurchaseTable from "./AddPurchaseTable";
import PurchaseOrderVendorName from "./PurchaseOrderVendorName";
import AddPurchaseOrderCustomer from "./AddPurchaseOrderCustomer";
import PurchaseDiscountType from "./PurchaseDiscountType";
import { useSearchParams } from 'react-router-dom';
import GeneralFileUploadPreview from "../../components/GeneralFileUploadPreview";
import moment from "moment";



function AddPurchaseOrderPage() {
  const setEntryData = SetEntryData();
  const entryMasterData = GetEntryData();
  const editableOrder = GetPurChaseOrderEdit();
  const resetEdit = ResetPurChaseOrderEdit();

  const navigate = useNavigate();
  const myPromiseModal = createModal(GeneralModal);
  const {register,setValue,getValues,handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const logicContext = useContext(LogicContext);
  const [purchaseList, setPurchaseList] = useState([]);

  // const [attachedFiles, setAttachedFile] = useState([]);
  const [imageUrlList, setImageUrlList] = useState([]);
  const [discountValue, setDiscountValue] = useState(0);
  const [shippingFee, setShippingFee] = useState(0);
  const [adjustmentValue, setAdjustmentValue] = useState(0);
  const [disCountTypeID, setDiscountTypeID] = useState(1);

  const [deliver_to, set_deliver_to] = useState('WAREHOUSE');
  const [selectedDeliverTo, setSelectedDeliverTo] = useState({});
  const mountRef = useRef(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const customVendorId = searchParams.get('vendor_id');
  const customVendorName = searchParams.get('vendor_name');
  const [attachmentFile, setAttachmentFile] = useState(null);





  useEffect(() => {
    mountRef.current = true;
    if (entryMasterData["Account_Head"] === undefined) {
      accountService.getPurchaseEntryMasterData().then((response) => {
        if (mountRef.current && response?.data !== undefined) {
          setEntryData(response.data);
        }
      });
    }
 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableOrder, entryMasterData]);


  useEffect(()=> {
    if(customVendorId !== null){
      setValue('Vendor_Id', customVendorId);
      setValue("Discount_Type_Id", 1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[customVendorId]);

  useEffect(()=> {
    document.title = 'New Purchase Order';

    if (editableOrder?.Purchase_Order_Ref_No) {
      document.title = 'Modify Purchase Order';
      setValue("Customer_Notes", editableOrder?.Customer_Notes);
      setValue("purchase_order_ref_no", editableOrder?.Purchase_Order_Ref_No);
      setValue("Delivery_To_Type_Id", editableOrder?.Delivery_To_Type_Id);
      setValue("Delivery_To_Id", editableOrder?.Delivery_To_Id);
      setValue("Vendor_Id", editableOrder?.Vendor_Id);
      setValue("Payment_Term_Id", editableOrder?.Payment_Term_Id);
      setValue("Item_Rates_Type_Id", editableOrder?.Item_Rates_Type_Id);
      setValue("Discount_Type_Id", editableOrder?.Discount_Type_Id);
      setValue("discount_value", editableOrder?.Discount_Value);
      setValue("shipping_charges", editableOrder?.Shipping_Charges);
      setValue("adjustment_amount", editableOrder?.Adjustment_Amount);
      setValue("attachment_url", editableOrder?.Attached_File_URL);
      setValue("Transaction_Discount_Type_Id", editableOrder?.Transaction_Discount_Type_Id);
      setDiscountValue(editableOrder?.Discount_Value);
      setShippingFee(editableOrder?.Shipping_Charges);
      setAdjustmentValue(editableOrder?.Adjustment_Amount);
      setDiscountTypeID(editableOrder?.Discount_Type_Id)
      if(editableOrder?.Attachments?.length > 0){
        reMapImageUri(editableOrder?.Attachments)
      }
    }

    return () => {
      mountRef.current = false;
      resetEdit();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[editableOrder])


    // ADD REMOTE IMAGE LINK TO CURRENT
    const reMapImageUri = (ImageList) => {
      let newList = ImageList.map((file, i) => {
        return ({...file, preview: imageService.PURCHASE_ORDER_ATTACHMENT_URL + file?.Purchase_Order_Ref_No
              + file?.Image_Reference_No + '.' + file?.Image_Format} ) });
  
      setImageUrlList(newList);
    }
  


  const onVendorSelect = (vendor) => {
    setValue("Vendor_Id", vendor.Supplier_Id);
  };



  const onDeliverSelect = (deliverTo) => {
    console.log('deliveray ', deliverTo);
    setSelectedDeliverTo(deliverTo);
    setValue("Delivery_To_Id", deliverTo.Warehouse_Id);
  };



  function onDeliverOptionSelect(val) {
    console.log("SEE ", val);
   
      set_deliver_to("WAREHOUSE");
      setValue("Delivery_To_Type_Id", 1);
      setSelectedDeliverTo({});
      setValue("Delivery_To_Id", val?.Warehouse_Id);
    
    // if (val === 2) {
    //   set_deliver_to("CUSTOMER");
    //   setValue("Delivery_To_Type_Id", 2);
    //   setSelectedDeliverTo({});
    //   setValue("Delivery_To_Id", 0);
    // }
  }


  function onItemRateSelect(val) {
    setValue("Item_Rates_Type_Id", val.Purchase_Item_Rate_Type_Id);
  }


  const onSubmit = async (option) => {
    const purchaseForm = getValues();
  
    //  validate
    if (!purchaseForm?.Delivery_To_Id) {
      return logicContext.showToast("Please select delivery option", "info");
    }
    //  validate
    if (!purchaseForm?.Vendor_Id) {
      return logicContext.showToast("Please select a Vendor", "info");
    }

    if (purchaseList.length === 0) {
      return logicContext.showToast("at least one or more item must be selected!", "error");
    }


    // <account_id>${item.Account_Id} </account_id>  Remove temporay

    var tempStringList = purchaseList?.map((item) => {

      let temp = `<a> <item_id>${item.Item_Id}  </item_id>
        <item_quantity>${item?.Item_Quantity} </item_quantity>
        <item_rate>${item?.Item_Rate} </item_rate>
        <tax_id>${item?.Item_Tax_Id} </tax_id>
          </a>`;
      return temp;
    });
    
    await myPromiseModal({title: "Confirmation", body: " Do you want to save this record?",
    showInput:false, placeHolder:''}).then((res) => {
        if (res.decision === true) {
          let option = 2;
          const newData = getValues();
          if (editableOrder?.Purchase_Order_Ref_No) {
            option = 3;
          }
          // attachedFile
          const formData = new FormData();
          for (const keyData in newData) {
            formData.set(keyData, newData[keyData] ? newData[keyData] : 0);
          }
          formData.set("option", option);
          formData.set("xml_string_item", `<root> ${tempStringList} </root>`);
          formData.set("discount_value", discountValue);
          formData.set("shipping_charges", shippingFee);
          formData.set("adjustment_amount", adjustmentValue);
          if(attachmentFile){
            formData.set('file', attachmentFile)
          }

          accountService.submitPurchaseOrder(formData).then((res) => {
            if (res?.data !== undefined) {
              const { message_text, message_id } = res.data[0];
              if (message_id === 1) {
                logicContext.showToast(message_text, "success");
                sessionStorage.setItem('reloadPage', 'true');

                navigate(-1);
              } else {
                return logicContext.showToast(message_text, "error");
              }
            }
          });
        }
      }).catch((err) => {
        // logicContext.showToast("error submitting record", "error",);
      })
      .catch((err) => {
        // logicContext.showToast(
        //   "error submitting form, please try again",
        //   "error"
        // );
      });
  };

  function onErrors(error) {
    console.error("Errorrrrr ", error);
    logicContext.showToast("Form error", "error");
  }

 

  
  function onFileSelected(file) {
    setAttachmentFile(file);
    
  }

  function expectedDeliveryDate() {
    let defaultDate = moment(Date.now()).format("YYYY-MM-DD");
    if (editableOrder?.Expected_Delivery_Date_String !== undefined) {
      defaultDate = moment(editableOrder?.Expected_Delivery_Date_String, 'DD/MM/YYYY').format("YYYY-MM-DD");
    }

    return (
        <input
          // defaultValue={defaultDate}
          defaultValue={defaultDate}
          key={defaultDate}
          className="bg-filterInput  pl-3  rounded max-h-full w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
          type="date"
          {...register("Expected_Delivery_Date", {
            required: "expected delivery date is required",
          })}
        />
    );
  }

  function purchaseOrderDate() {
        let defaultDate = moment(Date.now()).format("YYYY-MM-DD")
          if (editableOrder?.Purchase_Order_Date_String !== undefined) {
            defaultDate = moment(editableOrder?.Purchase_Order_Date_String, 'DD-MM-YYYY').format('YYYY-MM-DD');
          }

  
    return (
      <div className="">
        <input
          defaultValue={defaultDate}
          key={defaultDate}
          className="bg-filterInput  pl-3  rounded max-h-full w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
          type="date"
          {...register("Purchase_Order_Date", {
            required: " date is required",
          })}
        />
      </div>
    );
  }


  const onSelectionList = (tableList) => {
    setPurchaseList(tableList);
  };


  const calculateSubTotal = (list) => {
    let result = 0;
    list?.forEach((element) => {
      result += element.Item_Quantity * element.Item_Rate;
    });
    return result;
  };


  const onDiscountTypeIDSelect = (typeId) => {
    setValue('Discount_Type_Id',typeId )
    setDiscountTypeID(Number(typeId));
  };


  const calculateGrandTotal = (list) => {
    let result = 0;
    list?.forEach((element) => {
      result += element.Item_Quantity * element.Item_Rate;
    });

    if (disCountTypeID === 2) {
      let discount = (discountValue / 100) * result;
      result = result - discount;
    }

    result = result + shippingFee;
    result += adjustmentValue;
    if (disCountTypeID === 1) {
      result = result - discountValue;
    }

    return result;
  };




  return (
    <>
      <form onSubmit={handleSubmit(onSubmit, onErrors)}>
        <section className="container  max-auto  ">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid item xs={6}>
                <span className="text-sm ">Vendor Name</span>
                <Grid container>
                  <Grid item xs={1.9}>
                    <button className="flex outline-none items-center justify-center px-4  ">
                      <SearchIcon />
                    </button>
                  </Grid>
                  <Grid item xs={10}>
                    <PurchaseOrderVendorName defaultVal={{label: editableOrder?.Vendor_Name || customVendorName}}
                      onVendorSelect={onVendorSelect} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={4}>
                <span className="#476ef8">Deliver to</span>
                <PurchaseDeliverCheckBox
                  val={editableOrder?.Delivery_To_Id}
                  onDeliverOptionSelect={onDeliverOptionSelect}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={6}>
                <span className="text-sm ">{deliver_to} </span>
                <Grid container>
                  <Grid item xs={1.9}>
                    <button className="flex outline-none items-center justify-center px-4  ">
                      <SearchIcon />
                    </button>
                  </Grid>
                  <Grid item xs={10}>
                    {deliver_to === "WAREHOUSE" && (
                      <AddPurchaseWarehouse
                        defaultVal={{ label: editableOrder?.Delivery_To_Name }}
                        onDeliverSelect={onDeliverSelect}
                      />
                    )}

                    {deliver_to === "CUSTOMER" && (
                      <AddPurchaseOrderCustomer
                        defaultVal={{ label: editableOrder?.Delivery_To_Name }}
                        onDeliverSelect={onDeliverSelect}
                      />
                    )}
                  </Grid>
                </Grid>
                <div className="flex full mt-2 justify-between">
                  <div>
                    <span className="font-bold">
                      {selectedDeliverTo?.Customer_Full_Name}{" "}
                    </span>
                  </div>
                  <div>{/* <span className="text-danger">Remove</span> */}</div>
                </div>
                <div>
                  <p className="text-primary">{selectedDeliverTo?.Address}</p>
                  <p className="text-primary">
                    {selectedDeliverTo.Customer_Mobile_No}
                  </p>
                </div>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <div className="">
                <span className="text-sm ">Purchase Order Number</span>
                <span className="text-danger font-bold">*</span>
                <div className="">
                  <input
                    value={editableOrder?.Purchase_Order_Number}
                    className="bg-filterInput  pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                    placeholder="Auto generated"
                    readOnly={true}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className="">
                <span className="text-sm ">Expected Delivery Date</span>
                {/*  put date here */}
                {expectedDeliveryDate()}
              </div>
            </Grid>

            <Grid item xs={6}>
              <div className="">
                <span className="text-sm ">Reference Number</span>
                <div className="">
                  <input
                    type="number"
                    className="bg-filterInput pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                    placeholder=""
                  
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <span className="text-sm ">Shipment Reference</span>
              <input
                    type="text"
                    className="bg-filterInput pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                    placeholder=""
                    {...register("Shipment_Ref_Id", {
                    })}
                  />
            
            </Grid>

            <Grid item xs={6}>
              <div className="">
                <span className="text-sm ">Date</span>
                {/*  dageee */}
                {purchaseOrderDate()}
              </div>
            </Grid>
      

            <Grid item xs={6}>
              <span className="text-sm ">Item Rates</span>
              <span className="text-danger font-bold">*</span>
              <PurchaseOrderRate
                defaultVal={{ label: editableOrder?.Item_Rates_Type_Name }}
                onItemRateSelect={onItemRateSelect}
              />
            </Grid>

       

            <Grid item xs={12}>
              <AddPurchaseTable
                defaultList={editableOrder?.Purchase_Order_details}
                onSelectionList={onSelectionList}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-center ">
                <Grid className="my-2 border-2 px-2 py-2   " item xs={8}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <span className="#476ef8 text-md font-bold">Sub Total</span>
                  </Grid>
                  <Grid item xs={4}>
                    <span className="#476ef8"></span>
                  </Grid>
                  <Grid item xs={4} className="flex justify-center">
                    <span className="#476ef8 text-xl right-0">
                      <CurrencyFormat
                        value={parseFloat(
                          calculateSubTotal(purchaseList))?.toFixed(2)}
                        displayType={"text"}  thousandSeparator={true}
                        prefix={"₦"}  />
                    </span>
                  </Grid>

                  <Grid item xs={4}>
                    <span className="#476ef8 ">
                      <span className="text-md font-bold ">Discount</span>
                    </span>
                  </Grid>
                  <Grid item xs={4} className="flex justify-center">
                    <span className="text-sm">
                      <div className="">
                        <div className=" ">
                          <div className="">
                            <label className="">
                              <span className=" relative">
                        
                                <input
                                  className="bg-filterInput rounded pl-3 h-[7vh] w-full z-50 bottom-0 
                        outline-none border-transparent focus:border-transparent focus:ring-0"
                                  type="number"
                                  placeholder=""
                                  name="discount_type"
                                  key={discountValue}
                                  autoFocus="autoFocus"
                                  onChange={(e) =>
                                    setDiscountValue(Number(e.target.value))
                                  }
                                  defaultValue={discountValue}
                                />
                                <span className=" border-2  absolute -top-4 right-0 ">
                                  <PurchaseDiscountType 
                                  defaultVal={editableOrder?.Discount_Type_Id}
                                    onDiscountTypeSelect={onDiscountTypeIDSelect} />
                                </span>
                              </span>
                            </label>
                          </div>
                          <small className="text-danger"></small>
                        </div>
                      </div>
                    </span>
                  </Grid>
                  <Grid item xs={4} className="flex justify-center">
                    <CurrencyFormat value={parseFloat(discountValue)?.toFixed(2)}
                        displayType={"text"}  thousandSeparator={true}
                        prefix={"₦"}  />
                  </Grid>
                  <Grid item xs={4}>
                    <span className="text-md font-bold">
                      {" "}
                      Shipping Charges <br></br>
                      <i style={{ color: "#476EF8" }}>
                        Apply Tax on shipping Charge
                      </i>
                    </span>{" "}
                  </Grid>

                  <Grid item xs={4} className="flex justify-center">
                    <span className="">
                      <input
                        className="bg-filterInput mt-2 h-[7vh] pl-3 rounded  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                        type="number"
                        name="shipping_amount"
                        defaultValue={shippingFee}
                        autoFocus="autoFocus"
                        onChange={(e) => setShippingFee(Number(e.target.value))}
                        key={shippingFee}
                      />
                    </span>
                  </Grid>

                  <Grid item xs={4} className="flex justify-center">
                    <span className="#476ef8 ">
                      <CurrencyFormat
                        className={"text-xl"}
                        value={parseFloat(shippingFee)?.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </span>
                  </Grid>

                  <Grid item xs={4}>
                    <div className="">
                      <span className="text-md font-bold">Adjustment</span>
                      {/* <input
                          className="bg-filterInput h-[7vh] w-full rounded bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                          type="text"
                          placeholder="Adjustment"
                        /> */}
                    </div>
                  </Grid>
                  <Grid item xs={4} className="flex justify-center">
                    <span className="">
                      <input
                        className="bg-filterInput   h-[7vh] w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                        type="number"
                        step="any"
                        defaultValue={adjustmentValue}
                        autoFocus="autoFocus"
                        onChange={(e) =>
                          setAdjustmentValue(Number(e.target.value))
                        }
                        key={adjustmentValue}
                        name="adjustment_value"
                      />
                    </span>
                  </Grid>

                  <Grid item xs={4} className="flex justify-center">
                    <CurrencyFormat
                      className={
                        "text-xl " +
                        (adjustmentValue < 0 ? "text-danger" : "text-success")
                      }
                      value={parseFloat(adjustmentValue)?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <div className="">
                      <div>
                        <span className="text-xl  font-bold">Total (₦)</span>{" "}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={4}></Grid>
                  <Grid item xs={4} className="flex justify-center">
                    <span className=" text-xl rounded font-bold p-2 bg-dark ">
                      <CurrencyFormat
                        className="text-light "
                        value={parseFloat(
                          calculateGrandTotal(purchaseList))?.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </span>
                  </Grid>
                </Grid>
                </Grid>
            
              </div>
            </Grid>

            <Grid item xs={12}>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <div className="">
                      <span className="text-sm ">Customer Notes</span>
                      <input
                        {...register("Customer_Notes", {})}
                        className="bg-filterInput pl-3 rounded  h-[15vh] w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                        type="text"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="">
                      <span className="text-sm ">Terms and Conditions</span>
                      <div className="">
                        <input
                          readOnly={true}
                          type="readOnly"
                          className="bg-filterInput rounded h-[15vh] w-full pl-3 bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                          placeholder="Enter the terms and conditions of your business to 
                            be displayed in your transaction"
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
            <div className="">
                  <span className="text-sm ">Attach File(s)</span> 
                <GeneralFileUploadPreview defaultFileUrl={editableOrder?.Attached_File_URL} 
                onFileSelected={onFileSelected} />
                  <i> maximum file size 2MB </i>
                </div>
           
          
            </Grid>
            <Grid item xs={12}>
              <section>
                <div className="gird grid-cols-2 flex justify-between my-10 gap-4 w-full">
                  <div
                    type="cancel"
                    style={{ color: "#F17E7E", backgroundColor: "white" }}
                    className="text-sm  btn btn-danger rounded"
                    onClick={()=> navigate(-1)}
                  >
                    CANCEL
                  </div>
               
                  <div>
                    <span
                      type="submit"
                      style={{ color: "#476EF8" }}
                      className="text-sm  px-3 rounded mr-10 py-2"
                    >
                      SAVE AS DRAFT
                    </span>
                    <button
                      type="submit"
                      style={{ backgroundColor: "#476EF8" }}
                      className="text-sm text-white px-3 rounded py-2"
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </section>
            </Grid>
          </Grid>
        </section>
      </form>
    </>
  );
}

export default AddPurchaseOrderPage;
